import { render } from "./PedidosAdministradorComponent.vue?vue&type=template&id=02ed094c&scoped=true"
import script from "./PedidosAdministradorComponent.vue?vue&type=script&lang=js"
export * from "./PedidosAdministradorComponent.vue?vue&type=script&lang=js"

import "./PedidosAdministradorComponent.vue?vue&type=style&index=0&id=02ed094c&scoped=true&lang=css"

import exportComponent from "/Users/norberto/Documents/Marketing HL/adminmkthl/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02ed094c"]])

export default __exports__